export type ModelCatalogProvider = 'openai' | 'anthropic' | 'gemini' | 'ollama';

export interface IProviderModelOption {
  id: string;
  label: string;
  status: string;
  supportsVision: boolean;
}

export interface IProviderModelCatalog {
  provider: ModelCatalogProvider;
  label: string;
  source: string;
  lastSyncedAt: string | null;
  models: IProviderModelOption[];
}

export interface IModelCatalogs {
  openai: IProviderModelCatalog;
  anthropic: IProviderModelCatalog;
  gemini: IProviderModelCatalog;
  ollama: IProviderModelCatalog;
}

export interface IProviderModelCatalogDiff {
  provider: ModelCatalogProvider;
  checkedAt: string;
  approvedModels: IProviderModelOption[];
  discoveredModels: IProviderModelOption[];
  addedModels: IProviderModelOption[];
  removedModels: IProviderModelOption[];
}

export function getVisionModelOptions(catalog: IProviderModelCatalog | null | undefined): IProviderModelOption[] {
  return (catalog?.models ?? []).filter(option => option.supportsVision);
}

export function getFirstVisionModelId(catalog: IProviderModelCatalog | null | undefined): string {
  return getVisionModelOptions(catalog)[0]?.id ?? '';
}

export function ensureSelectedModelOption(
  options: IProviderModelOption[],
  selectedModel: string | null | undefined,
): IProviderModelOption[] {
  const normalizedModel = selectedModel?.trim();
  if (!normalizedModel) {
    return options;
  }
  if (options.some(option => option.id === normalizedModel)) {
    return options;
  }
  return [
    ...options,
    {
      id: normalizedModel,
      label: `${normalizedModel} (legacy current value)`,
      status: 'legacy',
      supportsVision: false
    }
  ];
}
